/* Info-Blase an der Zeile unter den Siegeln (26.08.2026).
   Klick oeffnet, Klick daneben oder Escape schliesst. Nur ein Element pro
   Section, deshalb reicht ein einfacher Toggle ohne Positionsrechnung. */
(function () {
  'use strict';
  function boot() {
    var btns = [].slice.call(document.querySelectorAll('[data-siegel-info]'));
    if (!btns.length) return;
    function closeAll() {
      btns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var w = b.closest('.smelu-siegel__infowrap');
        if (w) w.classList.remove('is-open');
      });
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrap = btn.closest('.smelu-siegel__infowrap');
        var open = wrap.classList.contains('is-open');
        closeAll();
        if (!open) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
